/**
 * Landing page course filters and legacy static samples.
 * Live course cards use the public API via `useLandingData`.
 */

import type { Course, GradeLevel } from '../types/courses';

export const gradeLevels: GradeLevel[] = [
  'All',
  'Preschool',
  'Elementary',
  'Middle',
  'High School',
  'Adult',
];

/** Unused on landing; kept for backwards compatibility. */
export const landingCourses: Course[] = [];
